type UploadOverlayProps = {
  visible: boolean;
};

export function UploadOverlay({ visible }: UploadOverlayProps) {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-brand-primary/10 backdrop-blur-sm pointer-events-none"
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-3 px-8 py-6 rounded-xl border-2 border-dashed border-brand-primary bg-surface-primary shadow-lg">
        <span className="text-4xl">📄</span>
        <p className="text-content-primary text-lg font-semibold">
          Drop .md files here
        </p>
        <p className="text-content-secondary text-sm">
          Markdown files only, up to 10MB each
        </p>
      </div>
    </div>
  );
}
